import { ClickableIcon } from "../../../../components/Icon/ClickableIcon.tsx";
import { useDeleteBrands } from "../hooks/useDeleteBrands.tsx";

export const BrandDeletionButton = ({ brandUuid }: { brandUuid: string }) => {
  const { deleteBrands, isDeletingBrands } = useDeleteBrands();

  return (
    <ClickableIcon
      name="X"
      size="sm"
      variant="inverse-primary"
      onClick={() => deleteBrands([brandUuid])}
      isLoading={isDeletingBrands}
    />
  );
};
